export default __webpack_public_path__ + "static/media/HiBob.68a2f2e0.svg";